// // Default Code Start

// // class FacetFiltersForm extends HTMLElement {
// //   constructor() {
// //     super();
// //     this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

// //     this.debouncedOnSubmit = debounce((event) => {
// //       this.onSubmitHandler(event);
// //     }, 800);

// //     const facetForm = this.querySelector('form');
// //     facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

// //     const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
// //     if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

// //     this.initHorizontalFacets();
// //   }
// //   initHorizontalFacets() {
// //     if (this.classList.contains('facets__horizontal')) {
// //       this.setupHorizontalFacets();
// //     }
// //     this.horizontalObserver = new MutationObserver((mutations) => {
// //       mutations.forEach((mutation) => {
// //         if (mutation.type === 'childList') {
// //           if (this.classList.contains('facets__horizontal')) {
// //             this.setupHorizontalFacets();
// //           }
// //         }
// //       });
// //     });
// //     this.querySelector('#FacetsWrapperDesktop') && this.horizontalObserver.observe(this.querySelector('#FacetsWrapperDesktop'), {
// //       childList: true,
// //       subtree: false
// //     });
// //   }
// //   setupHorizontalFacets() {
// //     document.removeEventListener('click', this.closeTab);
// //     this.querySelectorAll('.facets__disclosure__horizontal summary').forEach(item => {
// //       item.removeEventListener('click', this.openTab);
// //     });
// //     document.addEventListener('click', this.closeTab.bind(this));
// //     this.querySelectorAll('.facets__disclosure__horizontal summary').forEach((item) => {
// //       item.addEventListener('click', this.openTab.bind(this));
// //     });
// //   }
// //   openTab(event){
// //     var current = event.target.closest('details');
// //     if(current.classList.contains('details__opened')){
// //       current.classList.remove('details__opened');
// //     }else{
// //       setTimeout(function(){current.classList.add('details__opened');}, 100)
// //     }
// //   }
// //   closeTab(event){
// //     if(!this.classList.contains('facets__horizontal')) return;
// //     var index = -1;
// //     var current = event.target.closest('details');
// //     if(current){
// //       index = current.getAttribute('data-index');
// //     }
// //     this.querySelectorAll('.facets__disclosure__horizontal[open]').forEach((item) => {
// //       if(item.getAttribute('data-index') != index){
// //         item.removeAttribute('open');
// //         item.classList.remove('details__opened');
// //         item.querySelector('summary').setAttribute('aria-expanded', false);
// //       }
// //     });
// //   }

// //   static setListeners() {
// //     const onHistoryChange = (event) => {
// //       const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
// //       if (searchParams === FacetFiltersForm.searchParamsPrev) return;
// //       FacetFiltersForm.renderPage(searchParams, null, false);
// //     };
// //     window.addEventListener('popstate', onHistoryChange);
// //   }

// //   static toggleActiveFacets(disable = true) {
// //     document.querySelectorAll('.js-facet-remove').forEach((element) => {
// //       element.classList.toggle('disabled', disable);
// //     });
// //   }

// //   static renderPage(searchParams, event, updateURLHash = true) {
// //     FacetFiltersForm.searchParamsPrev = searchParams;
// //     const sections = FacetFiltersForm.getSections();

// //     placeCollectionLoader();
// //     document.getElementById('ProductGridContainer').classList.add('loading_now');
// //     document.querySelector('.collection_facets_loader').classList.add('loading_now');
    
// //     sections.forEach((section) => {
// //       const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
// //       const filterDataUrl = (element) => element.url === url;

// //       FacetFiltersForm.filterData.some(filterDataUrl)
// //         ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
// //         : FacetFiltersForm.renderSectionFromFetch(url, event);
// //     });

// //     if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
// //   }

// //   static renderSectionFromFetch(url, event) {
// //     fetch(url)
// //       .then((response) => response.text())
// //       .then((responseText) => {
// //         const html = responseText;
// //         FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
// //         FacetFiltersForm.renderFilters(html, event);
// //         FacetFiltersForm.renderProductGridContainer(html);
// //         FacetFiltersForm.renderProductCount(html);
// //         FacetFiltersForm.removePreloader();
// //         if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
// //       });
// //   }

// //   static renderSectionFromCache(filterDataUrl, event) {
// //     const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
// //     FacetFiltersForm.renderFilters(html, event);
// //     FacetFiltersForm.renderProductGridContainer(html);
// //     FacetFiltersForm.renderProductCount(html);    
// //     FacetFiltersForm.removePreloader();
// //     if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
// //   }

// //   static removePreloader(){
// //     window.dispatchEvent(new CustomEvent('updateGrid'));
// //     document.querySelector('.collection_facets_loader').classList.remove('loading_now');
// //     document.getElementById('ProductGridContainer').classList.remove('loading_now');
// //   }
  
// //   static renderProductGridContainer(html) {
// //     document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
// //       .parseFromString(html, 'text/html')
// //       .getElementById('ProductGridContainer').innerHTML;

// //     document
// //       .getElementById('ProductGridContainer')
// //       .querySelectorAll('.scroll-trigger')
// //       .forEach((element) => {
// //         element.classList.add('scroll-trigger--cancel');
// //       });
// //   }

// //   static renderProductCount(html) {
// //     const countContainer = document.getElementById('ProductCount');
// //     if(!countContainer) return false;
// //     const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
// //     const container = document.getElementById('ProductCount');
// //     container.innerHTML = count;
// //   }

// //   static renderFilters(html, event) {
// //     const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
// //     const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
// //       '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
// //     );
// //     const facetDetailsElementsFromDom = document.querySelectorAll(
// //       '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
// //     );
// //     var removed = false;
// //     Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
// //       if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
// //         currentElement.closest('details').remove();
// //       }
// //     });

// //     const matchesId = (element) => {
// //       const jsFilter = event ? event.target.closest('.js-filter') : undefined;
// //       return jsFilter ? element.id === jsFilter.id : false;
// //     };

// //     const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
// //     const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

// //     facetsToRender.forEach((elementToRender, index) => {
// //       const currentElement = document.getElementById(elementToRender.id);
// //       if (currentElement) {
// //         document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
// //       } else {
// //         if (elementToRender.parentElement) {
// //           var _parent_current = document.querySelector(`#${elementToRender.parentElement.id}`);
// //         }
// //         if (index > 0 && elementToRender.parentElement && _parent_current) {
// //           const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
// //           if (elementToRender.className === previousElementClassName) {
// //             document.getElementById(previousElementId).after(elementToRender);
// //             return;
// //           }
// //         }

// //         if (elementToRender.parentElement) {
// //           var _index = elementToRender.parentElement.dataset.index;
// //           var _fl = document.querySelector(`#${elementToRender.parentElement.id}`);
// //           if(_fl){
// //             if(_fl.querySelector(`.js-filter`)){
// //               _fl.querySelector(`.js-filter`).before(elementToRender);
// //             }
// //           }
// //           else{
// //             if(elementToRender.parentElement.classList.contains('mobile-facets__details')){
// //               var parent = document.querySelector(`#FacetFiltersFormMobile .facet-drawer__content__scroll`);
// //             }
// //             else{
// //               var parent = document.querySelector(`#FacetsWrapperDesktop`);
// //             }
// //             parent.insertBefore(elementToRender.parentElement, parent.children[_index])
// //           }
// //         }
// //       }
// //     });

// //     FacetFiltersForm.renderActiveFacets(parsedHTML);
// //     FacetFiltersForm.renderAdditionalElements(parsedHTML);

// //     if (countsToRender) {
// //       const closestJSFilterID = event.target.closest('.js-filter').id;

// //       if (closestJSFilterID) {
// //         FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
// //         FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

// //         const newFacetDetailsElement = document.getElementById(closestJSFilterID);
// //         const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
// //           ? `.mobile-facets__close-button`
// //           : `.facets__summary`;
// //         const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

// //         const isTextInput = event.target.getAttribute('type') === 'text';

// //         if (newElementToActivate && !isTextInput) newElementToActivate.focus();
// //       }
// //     }
// //   }

// //   static renderActiveFacets(html) {
// //     const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

// //     activeFacetElementSelectors.forEach((selector) => {
// //       const activeFacetsElement = html.querySelector(selector);
// //       if (!activeFacetsElement) return;
// //       document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
// //     });

// //     FacetFiltersForm.toggleActiveFacets(false);
// //   }

// //   static renderAdditionalElements(html) {
// //     const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

// //     mobileElementSelectors.forEach((selector) => {
// //       if (!html.querySelector(selector)) return;
// //       document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
// //     });

// //     document.getElementById('FacetFiltersFormMobile')&&document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
// //   }

// //   static renderCounts(source, target) {
// //     const targetSummary = target.querySelector('.facets__summary');
// //     const sourceSummary = source.querySelector('.facets__summary');

// //     if (sourceSummary && targetSummary) {
// //       targetSummary.outerHTML = sourceSummary.outerHTML;
// //     }

// //     const targetHeaderElement = target.querySelector('.facets__header');
// //     const sourceHeaderElement = source.querySelector('.facets__header');

// //     if (sourceHeaderElement && targetHeaderElement) {
// //       targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
// //     }

// //     const targetWrapElement = target.querySelector('.facets-wrap');
// //     const sourceWrapElement = source.querySelector('.facets-wrap');

// //     if (sourceWrapElement && targetWrapElement) {
// //       const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
// //       if (isShowingMore) {
// //         sourceWrapElement
// //           .querySelectorAll('.facets__item.hidden')
// //           .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
// //       }

// //       targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
// //     }
// //   }

// //   static renderMobileCounts(source, target) {
// //     const targetFacetsList = target.querySelector('.mobile-facets__list');
// //     const sourceFacetsList = source.querySelector('.mobile-facets__list');

// //     if (sourceFacetsList && targetFacetsList) {
// //       targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
// //     }
// //   }

// //   static updateURLHash(searchParams) {
// //     history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
// //   }

// //   static getSections() {
// //     return [
// //       {
// //         section: document.getElementById('product-grid').dataset.id,
// //       },
// //     ];
// //   }

// //   createSearchParams(form) {
// //     const formData = new FormData(form);
// //     return new URLSearchParams(formData).toString();
// //   }

// //   onSubmitForm(searchParams, event) {
// //     FacetFiltersForm.renderPage(searchParams, event);
// //   }

// //   onSubmitHandler(event) {
// //     event.preventDefault();
// //     const sortFilterForms = document.querySelectorAll('facet-filters-form form');
// //     if (event.srcElement.className == 'mobile-facets__checkbox') {
// //       const searchParams = this.createSearchParams(event.target.closest('form'));
// //       this.onSubmitForm(searchParams, event);
// //     } else {
// //       const forms = [];
// //       const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

// //       sortFilterForms.forEach((form) => {
// //         if (!isMobile) {
// //           if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
// //             forms.push(this.createSearchParams(form));
// //           }
// //         } else if (form.id === 'FacetFiltersFormMobile') {
// //           forms.push(this.createSearchParams(form));
// //         }
// //       });
// //       this.onSubmitForm(forms.join('&'), event);
// //     }
// //   }

// //   onActiveFilterClick(event) {
// //     event.preventDefault();
// //     FacetFiltersForm.toggleActiveFacets();
// //     const url =
// //       event.currentTarget.href.indexOf('?') == -1
// //         ? ''
// //         : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
// //     FacetFiltersForm.renderPage(url);
// //   }
// // }

// // FacetFiltersForm.filterData = [];
// // FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
// // FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
// // customElements.define('facet-filters-form', FacetFiltersForm);
// // FacetFiltersForm.setListeners();

// // class PriceRange extends HTMLElement {
// //   constructor() {
// //     super();
// //     this.querySelectorAll('input').forEach((element) => {
// //       element.addEventListener('change', this.onRangeChange.bind(this));
// //       element.addEventListener('keydown', this.onKeyDown.bind(this));
// //     });
// //     this.setMinAndMaxValues();
// //   }

// //   onRangeChange(event) {
// //     this.adjustToValidValues(event.currentTarget);
// //     this.setMinAndMaxValues();
// //   }

// //   onKeyDown(event) {
// //     if (event.metaKey) return;

// //     const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
// //     if (!event.key.match(pattern)) event.preventDefault();
// //   }

// //   setMinAndMaxValues() {
// //     const inputs = this.querySelectorAll('input');
// //     const minInput = inputs[0];
// //     const maxInput = inputs[1];
// //     if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
// //     if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
// //     if (minInput.value === '') maxInput.setAttribute('data-min', 0);
// //     if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
// //   }

// //   adjustToValidValues(input) {
// //     const value = Number(input.value);
// //     const min = Number(input.getAttribute('data-min'));
// //     const max = Number(input.getAttribute('data-max'));

// //     if (value < min) input.value = min;
// //     if (value > max) input.value = max;
// //   }
// // }

// // customElements.define('price-range', PriceRange);

// // class FacetRemove extends HTMLElement {
// //   constructor() {
// //     super();
// //     const facetLink = this.querySelector('a');
// //     facetLink.setAttribute('role', 'button');
// //     facetLink.addEventListener('click', this.closeFilter.bind(this));
// //     facetLink.addEventListener('keyup', (event) => {
// //       event.preventDefault();
// //       if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
// //     });
// //   }

// //   closeFilter(event) {
// //     event.preventDefault();
// //     const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
// //     form.onActiveFilterClick(event);
// //   }
// // }

// // customElements.define('facet-remove', FacetRemove);
// // Default Code END

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.initHorizontalFacets();
    
    // Initialize price sliders
    this.initPriceSliders();
    
  }
  
  initHorizontalFacets() {
    if (this.classList.contains('facets__horizontal')) {
      this.setupHorizontalFacets();
    }
    this.horizontalObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          if (this.classList.contains('facets__horizontal')) {
            this.setupHorizontalFacets();
          }
        }
      });
    });
    this.querySelector('#FacetsWrapperDesktop') && this.horizontalObserver.observe(this.querySelector('#FacetsWrapperDesktop'), {
      childList: true,
      subtree: false
    });
  }
  
  setupHorizontalFacets() {
    document.removeEventListener('click', this.closeTab);
    this.querySelectorAll('.facets__disclosure__horizontal summary').forEach(item => {
      item.removeEventListener('click', this.openTab);
    });
    document.addEventListener('click', this.closeTab.bind(this));
    this.querySelectorAll('.facets__disclosure__horizontal summary').forEach((item) => {
      item.addEventListener('click', this.openTab.bind(this));
    });
  }
  
  openTab(event){
    var current = event.target.closest('details');
    if(current.classList.contains('details__opened')){
      current.classList.remove('details__opened');
    }else{
      setTimeout(function(){current.classList.add('details__opened');}, 100)
    }
  }
  
  closeTab(event){
    if(!this.classList.contains('facets__horizontal')) return;
    var index = -1;
    var current = event.target.closest('details');
    if(current){
      index = current.getAttribute('data-index');
    }
    this.querySelectorAll('.facets__disclosure__horizontal[open]').forEach((item) => {
      if(item.getAttribute('data-index') != index){
        item.removeAttribute('open');
        item.classList.remove('details__opened');
        item.querySelector('summary').setAttribute('aria-expanded', false);
      }
    });
  }
//   initPriceSliders() {
//   const self = this;
  
//   const sliderContainers = this.querySelectorAll('.facets__price--slider');
  
//   sliderContainers.forEach(container => {
//     // Check if price filter is active via class
//     const hasPriceFilterClass = container.classList.contains('price-filter-active');
    
//     const minSlider = container.querySelector('.price-slider-min');
//     const maxSlider = container.querySelector('.price-slider-max');
//     const activeTrack = container.querySelector('.slider-active-track');
//     const minDisplay = container.querySelector('.price-value-min');
//     const maxDisplay = container.querySelector('.price-value-max');
    
//     const hiddenInputs = container.querySelectorAll('.field__input');
//     let minInput = null;
//     let maxInput = null;
    
//     hiddenInputs.forEach(input => {
//       if (input.id && (input.id.includes('GTE') || input.id.includes('gte'))) {
//         minInput = input;
//       } else if (input.id && (input.id.includes('LTE') || input.id.includes('lte'))) {
//         maxInput = input;
//       }
//     });
    
//     if (!minSlider || !maxSlider) return;
    
//     const rangeMin = parseFloat(minSlider.min);
//     const rangeMax = parseFloat(minSlider.max);
    
//     function updateTrack() {
//       const min = parseFloat(minSlider.value);
//       const max = parseFloat(maxSlider.value);
//       const minPercent = ((min - rangeMin) / (rangeMax - rangeMin)) * 100;
//       const maxPercent = ((max - rangeMin) / (rangeMax - rangeMin)) * 100;
      
//       if (activeTrack) {
//         activeTrack.style.left = Math.min(Math.max(minPercent, 0), 100) + '%';
//         activeTrack.style.width = Math.min(Math.max(maxPercent - minPercent, 0), 100) + '%';
//       }
//     }
    
//     function updateValues(updateHiddenInputs = false) {
//       const min = parseFloat(minSlider.value);
//       const max = parseFloat(maxSlider.value);
      
//       if (minDisplay) minDisplay.textContent = min.toFixed(2);
//       if (maxDisplay) maxDisplay.textContent = max.toFixed(2);
      
//       if (updateHiddenInputs) {
//         const isMinDefault = Math.abs(min - rangeMin) < 0.01;
//         const isMaxDefault = Math.abs(max - rangeMax) < 0.01;
        
//         if (minInput) {
//           minInput.value = isMinDefault ? '' : min.toFixed(2);
//         }
//         if (maxInput) {
//           maxInput.value = isMaxDefault ? '' : max.toFixed(2);
//         }
//       }
      
//       updateTrack();
//     }
    
//     let timeoutId = null;
//     function triggerFormSubmit() {
//       clearTimeout(timeoutId);
//       timeoutId = setTimeout(() => {
//         const minVal = minInput ? minInput.value : '';
//         const maxVal = maxInput ? maxInput.value : '';
//         const isActive = (minVal && parseFloat(minVal) > 0) || (maxVal && parseFloat(maxVal) > 0);
        
//         if (isActive) {
//           const form = container.closest('form');
//           if (form) {
//             const inputEvent = new Event('input', { bubbles: true, cancelable: true });
//             form.dispatchEvent(inputEvent);
//           }
//         }
//       }, 300);
//     }
    
//     minSlider.addEventListener('input', function(e) {
//       let value = parseFloat(this.value);
//       const max = parseFloat(maxSlider.value);
      
//       if (value > max) {
//         this.value = max;
//         value = max;
//       }
      
//       updateValues(true);
//       triggerFormSubmit();
//     });
    
//     maxSlider.addEventListener('input', function(e) {
//       let value = parseFloat(this.value);
//       const min = parseFloat(minSlider.value);
      
//       if (value < min) {
//         this.value = min;
//         value = min;
//       }
      
//       updateValues(true);
//       triggerFormSubmit();
//     });
    
//     // If price filter is active from class, restore values
//     if (hasPriceFilterClass) {
//       const urlParams = new URLSearchParams(window.location.search);
//       const urlMin = parseFloat(urlParams.get('filter.v.price.gte'));
//       const urlMax = parseFloat(urlParams.get('filter.v.price.lte'));
      
//       if (!isNaN(urlMin) && urlMin >= rangeMin) {
//         minSlider.value = Math.min(Math.max(urlMin, rangeMin), rangeMax);
//       }
//       if (!isNaN(urlMax) && urlMax <= rangeMax) {
//         maxSlider.value = Math.max(Math.min(urlMax, rangeMax), rangeMin);
//       }
      
//       updateValues(true);
//     } else {
//       // No price filter - set defaults but keep hidden inputs empty
//       minSlider.value = rangeMin;
//       maxSlider.value = rangeMax;
      
//       if (minDisplay) minDisplay.textContent = rangeMin.toFixed(2);
//       if (maxDisplay) maxDisplay.textContent = rangeMax.toFixed(2);
      
//       if (minInput) minInput.value = '';
//       if (maxInput) maxInput.value = '';
      
//       updateTrack();
//     }
    
//     container.addEventListener('click', function(e) {
//       if (e.target.closest('.price-slider')) {
//         e.stopPropagation();
//       }
//     });
//   });
// }
initPriceSliders() {
  // Wait for DOM to be ready
  const self = this;
  
  // Get current URL search params to check if price filter is active
  const urlParams = new URLSearchParams(window.location.search);
  const hasPriceFilter = urlParams.has('filter.v.price.gte') || urlParams.has('filter.v.price.lte');
  
  // Find all price slider containers
  const sliderContainers = this.querySelectorAll('.facets__price--slider');
  
  sliderContainers.forEach(container => {
    const minSlider = container.querySelector('.price-slider-min');
    const maxSlider = container.querySelector('.price-slider-max');
    const activeTrack = container.querySelector('.slider-active-track');
    const minDisplay = container.querySelector('.price-value-min');
    const maxDisplay = container.querySelector('.price-value-max');
    
    // Find the hidden inputs (they have the field__input class)
    const hiddenInputs = container.querySelectorAll('.field__input');
    let minInput = null;
    let maxInput = null;
    
    hiddenInputs.forEach(input => {
      if (input.id && (input.id.includes('GTE') || input.id.includes('gte'))) {
        minInput = input;
      } else if (input.id && (input.id.includes('LTE') || input.id.includes('lte'))) {
        maxInput = input;
      }
    });
    
    if (!minSlider || !maxSlider) return;
    
    const rangeMin = parseFloat(minSlider.min);
    const rangeMax = parseFloat(minSlider.max);
    
    // Function to update the active track
    function updateTrack() {
      const min = parseFloat(minSlider.value);
      const max = parseFloat(maxSlider.value);
      const minPercent = ((min - rangeMin) / (rangeMax - rangeMin)) * 100;
      const maxPercent = ((max - rangeMin) / (rangeMax - rangeMin)) * 100;
      
      if (activeTrack) {
        activeTrack.style.left = Math.min(Math.max(minPercent, 0), 100) + '%';
        activeTrack.style.width = Math.min(Math.max(maxPercent - minPercent, 0), 100) + '%';
      }
    }
    
    // Function to update displays and hidden inputs
    function updateValues() {
      const min = parseFloat(minSlider.value);
      const max = parseFloat(maxSlider.value);
      
      // Update display values
      if (minDisplay) minDisplay.textContent = min.toFixed(2);
      if (maxDisplay) maxDisplay.textContent = max.toFixed(2);
      
      // Update hidden inputs (for form submission)
      if (minInput) {
        minInput.value = min.toFixed(2);
        // Trigger change event for the hidden input
        const changeEvent = new Event('change', { bubbles: true });
        minInput.dispatchEvent(changeEvent);
      }
      if (maxInput) {
        maxInput.value = max.toFixed(2);
        const changeEvent = new Event('change', { bubbles: true });
        maxInput.dispatchEvent(changeEvent);
      }
      
      updateTrack();
    }
    
    // Function to check if price filter is active in URL
    function isPriceFilterActive() {
      return urlParams.has('filter.v.price.gte') || urlParams.has('filter.v.price.lte');
    }
    
    // Debounced function to trigger form submission
    let timeoutId = null;
    function triggerFormSubmit() {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const form = container.closest('form');
        if (form) {
          // Find the form's input event listener
          const inputEvent = new Event('input', { bubbles: true, cancelable: true });
          form.dispatchEvent(inputEvent);
          
          // Also trigger change event for the hidden inputs
          if (minInput) {
            const changeEvent = new Event('change', { bubbles: true });
            minInput.dispatchEvent(changeEvent);
          }
          if (maxInput) {
            const changeEvent = new Event('change', { bubbles: true });
            maxInput.dispatchEvent(changeEvent);
          }
        }
      }, 300);
    }
    
    // Event listeners for min slider
    minSlider.addEventListener('input', function(e) {
      let value = parseFloat(this.value);
      const max = parseFloat(maxSlider.value);
      
      if (value > max) {
        this.value = max;
        value = max;
      }
      
      updateValues();
      triggerFormSubmit();
    });
    
    // Event listeners for max slider
    maxSlider.addEventListener('input', function(e) {
      let value = parseFloat(this.value);
      const min = parseFloat(minSlider.value);
      
      if (value < min) {
        this.value = min;
        value = min;
      }
      
      updateValues();
      triggerFormSubmit();
    });
    
    // Check if price filter is active in URL
    if (!hasPriceFilter) {
      // If no price filter is active, set sliders to min/max range but DON'T update hidden inputs
      // or trigger form submission
      minSlider.value = rangeMin;
      maxSlider.value = rangeMax;
      
      // Update only the display values and track, but NOT the hidden inputs
      if (minDisplay) minDisplay.textContent = rangeMin.toFixed(2);
      if (maxDisplay) maxDisplay.textContent = rangeMax.toFixed(2);
      
      // IMPORTANT: Do NOT update hidden inputs when no filter is active
      // This prevents the price filter from being automatically selected
      
      updateTrack();
    } else {
      // If price filter is active, use the values from URL
      const urlMin = parseFloat(urlParams.get('filter.v.price.gte'));
      const urlMax = parseFloat(urlParams.get('filter.v.price.lte'));
      
      if (!isNaN(urlMin) && urlMin >= rangeMin) {
        minSlider.value = Math.min(Math.max(urlMin, rangeMin), rangeMax);
      }
      if (!isNaN(urlMax) && urlMax <= rangeMax) {
        maxSlider.value = Math.max(Math.min(urlMax, rangeMax), rangeMin);
      }
      
      // Update all values including hidden inputs
      updateValues();
    }
    
    // Add click handler for the price range wrapper to prevent event bubbling issues
    container.addEventListener('click', function(e) {
      // Allow clicks on the slider but prevent any unwanted form submissions
      if (e.target.closest('.price-slider')) {
        e.stopPropagation();
      }
    });
  });
}
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    placeCollectionLoader();
    document.getElementById('ProductGridContainer').classList.add('loading_now');
    document.querySelector('.collection_facets_loader').classList.add('loading_now');
    
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.removePreloader();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);    
    FacetFiltersForm.removePreloader();
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static removePreloader(){
    window.dispatchEvent(new CustomEvent('updateGrid'));
    document.querySelector('.collection_facets_loader').classList.remove('loading_now');
    document.getElementById('ProductGridContainer').classList.remove('loading_now');
  }
  
  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const countContainer = document.getElementById('ProductCount');
    if(!countContainer) return false;
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    container.innerHTML = count;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    var removed = false;
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.closest('details').remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (elementToRender.parentElement) {
          var _parent_current = document.querySelector(`#${elementToRender.parentElement.id}`);
        }
        if (index > 0 && elementToRender.parentElement && _parent_current) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          var _index = elementToRender.parentElement.dataset.index;
          var _fl = document.querySelector(`#${elementToRender.parentElement.id}`);
          if(_fl){
            if(_fl.querySelector(`.js-filter`)){
              _fl.querySelector(`.js-filter`).before(elementToRender);
            }
          }
          else{
            if(elementToRender.parentElement.classList.contains('mobile-facets__details')){
              var parent = document.querySelector(`#FacetFiltersFormMobile .facet-drawer__content__scroll`);
            }
            else{
              var parent = document.querySelector(`#FacetsWrapperDesktop`);
            }
            parent.insertBefore(elementToRender.parentElement, parent.children[_index])
          }
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // Reinitialize price sliders after filter update
    document.querySelectorAll('facet-filters-form').forEach(form => {
      if (form.initPriceSliders) {
        form.initPriceSliders();
      }
    });

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')&&document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  // createSearchParams(form) {
  //   const formData = new FormData(form);
  //   const searchParams = new URLSearchParams(formData);
    
  //   // FIX: Preserve the 'q' parameter from the URL if it exists
  //   const currentUrlParams = new URLSearchParams(window.location.search);
  //   const qParam = currentUrlParams.get('q');
    
  //   if (qParam && !searchParams.has('q')) {
  //     searchParams.set('q', qParam);
  //   }
    
  //   return searchParams.toString();
  // }
  createSearchParams(form) {
  const formData = new FormData(form);
  const searchParams = new URLSearchParams(formData);
  
  // Remove empty price parameters
  const priceGte = searchParams.get('filter.v.price.gte');
  const priceLte = searchParams.get('filter.v.price.lte');
  
  if (!priceGte || priceGte === '' || parseFloat(priceGte) <= 0) {
    searchParams.delete('filter.v.price.gte');
  }
  
  if (!priceLte || priceLte === '' || parseFloat(priceLte) <= 0) {
    searchParams.delete('filter.v.price.lte');
  }
  
  // Also remove any other empty parameters
  for (const [key, value] of searchParams.entries()) {
    if (!value || value === '') {
      searchParams.delete(key);
    }
  }
  
  // Preserve the 'q' parameter from the URL if it exists
  const currentUrlParams = new URLSearchParams(window.location.search);
  const qParam = currentUrlParams.get('q');
  
  if (qParam && !searchParams.has('q')) {
    searchParams.set('q', qParam);
  }
  
  return searchParams.toString();
}

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    
    // FIX: Get q parameter from URL
    const currentUrlParams = new URLSearchParams(window.location.search);
    const qParam = currentUrlParams.get('q');
    
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        let formParams = '';
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            formParams = this.createSearchParams(form);
            // FIX: Ensure q is in the form params
            if (qParam && !formParams.includes('q=')) {
              formParams = formParams ? `${formParams}&q=${encodeURIComponent(qParam)}` : `q=${encodeURIComponent(qParam)}`;
            }
            forms.push(formParams);
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          formParams = this.createSearchParams(form);
          if (qParam && !formParams.includes('q=')) {
            formParams = formParams ? `${formParams}&q=${encodeURIComponent(qParam)}` : `q=${encodeURIComponent(qParam)}`;
          }
          forms.push(formParams);
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    
    // FIX: Get q parameter from current URL
    const currentUrlParams = new URLSearchParams(window.location.search);
    const qParam = currentUrlParams.get('q');
    
    // FIX: If we have a q param and it's not in the URL we're navigating to, add it
    let finalUrl = url;
    if (qParam && !url.includes('q=')) {
      finalUrl = url ? `${url}&q=${encodeURIComponent(qParam)}` : `q=${encodeURIComponent(qParam)}`;
    }
    
    FacetFiltersForm.renderPage(finalUrl);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    // this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);